import { useEffect, useState } from "react";
import locationTracker from "./index";
import { LocationAndEtaDetailType } from "../base/types";

export type LocationStateType = {
  location: LocationAndEtaDetailType,
  timestamp: number
};

export type UseLocationType = () => LocationStateType;

/**
 * use useLocation hook to obtain latest location.
 */
export const useLocation: UseLocationType = () => {
  const [state, setState] = useState<LocationStateType>({
    location: locationTracker.location,
    timestamp: locationTracker.timestamp
  });
  useEffect(() => {
    return locationTracker.fastSubscribe((nextLocation, nextTimestamp) => {
      setState({
        location: nextLocation,
        timestamp: nextTimestamp
      });
    })
  }, [])
  return state;
}

/**
 * use useLastNotifiedLocation hook to obtain the latest location
 * that we have notified to slow-listeners (ie: socket)
 */
export const useLastNotifiedLocation: UseLocationType = () => {
  const [state, setState] = useState<LocationStateType>({
    location: locationTracker.lastNotifiedLocation,
    timestamp: locationTracker.notifyTimestamp
  });
  useEffect(() => {
    return locationTracker.subscribe((nextLocation, nextTimestamp) => {
      setState({
        location: nextLocation,
        timestamp: nextTimestamp
      });
    })
  }, [])
  return state;
}
